/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RegolaDTO } from './regola-dto';


export interface TariffaMensaDTO { 
    id?: string;
    servizio_id?: string;
    numero_pasti_per_contributo?: number;
    is_non_autosufficiente_esente?: boolean;
    regole?: Array<RegolaDTO>;
    version?: number;
    is_esenti_esclusi_conteggio_fratelli?: boolean;
    decorrenza_esenzione?: TariffaMensaDTODecorrenzaEsenzioneEnum;
}
export enum TariffaMensaDTODecorrenzaEsenzioneEnum {
    TUTTO_IL_SERVIZIO = 'TUTTO_IL_SERVIZIO',
    DAL_MESE = 'DAL_MESE'
};



